import FillInTheBlanks from "../../components/ClassOne/English/FillInTheBlanks";
import IdentifyVerbs from "../../components/ClassOne/English/WriteVerbs";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/verbs/write-the-verb", title: "Choose the Verb", component: IdentifyVerbs },
    { url: "/class-one/english/verbs/fill-the-blanks", title: "Fill in the Blanks", component: FillInTheBlanks },
];


export default topics;